<template>
    <el-select v-model="modelValue" placeholder="请选择性别" @change="handleChange">
        <el-option v-if="isAllItem" label="全部" :value="''"></el-option>
        <el-option
            v-for="item in sexOptions"
            :key="item.value"
            :label="item.name"
            :value="item.value">
        </el-option>
    </el-select>
</template>
<script>
import { mapState, mapActions } from 'vuex'
export default {
    props: {
        value: {
            type: [String, Number],
            default: ''
        },
        isAllItem: {
            type: Boolean,
            default: true
        }
    },
    model: {
        prop: 'value',
        event: 'input'
    },
    data() {
        return {

        }
    },
    computed: {
        ...mapState({
            sexOptions: 'sexOptions'
        }),
        modelValue: {
            get(v) {
                return this.value
            },
            set(v) {
                this.$emit('input', v)
            }
        }
    },
    mounted() {
        if (this.sexOptions.length === 0) {
            this.getSexOptions()
        }
    },
    methods: {
        ...mapActions({
            getSexOptions: 'getSexOptions'
        }),
        handleChange(v) {
            this.$emit('input', v)
        }
    }
}
</script>
<style scoped lang="less">

</style>